var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_2627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#DE872F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.0284 10.075C16.4218 7.37417 14.0651 6.16667 12.0001 6.16667C12.0001 6.16667 12.0001 6.16667 11.9943 6.16667C9.9351 6.16667 7.58427 7.37417 6.97177 10.0692C6.28343 13.0792 8.12677 15.6283 9.7951 17.2383C10.4134 17.8333 11.2068 18.1308 12.0001 18.1308C12.7934 18.1308 13.5868 17.8333 14.1993 17.2383C15.8676 15.6283 17.7109 13.085 17.0284 10.075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2708 13.0208C11.1599 13.0208 11.0491 12.98 10.9616 12.8925L10.0866 12.0175C9.91743 11.8483 9.91743 11.5683 10.0866 11.3992C10.2558 11.23 10.5358 11.23 10.7049 11.3992L11.2708 11.965L13.2949 9.94084C13.4641 9.77167 13.7441 9.77167 13.9133 9.94084C14.0824 10.11 14.0824 10.39 13.9133 10.5592L11.5799 12.8925C11.4924 12.98 11.3816 13.0208 11.2708 13.0208Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_2627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisit);
export default __webpack_public_path__ + "static/media/visit.d3d200b89ccaa7f4151273da9190185c.svg";
export { ForwardRef as ReactComponent };